import React, { useEffect, useState, Fragment } from 'react';
import { Container, Row, Col, Dropdown } from 'react-bootstrap';
import Chart from "react-apexcharts";
// import { Dropdown } from 'bootstrap';
import ReactDatatable from "@ashvin27/react-datatable";
import Header from '../../Components/Header';
import Sidebar from '../../Components/Sidebar';
import { toastAlert } from '../../lib/toastAlert';
import Select from "react-select";
import { AdminEditUserPlans, ChartDBData, CountForAdminPack, Notifcation, PackBuyerCount, PackBuyerssList, PackBuyerssListTabel, PackTableList, RevenueAnnual } from '../../actions/users';
import moment from 'moment';
import Exportexcel from '../pdf/Excelexport';
import Exportpdf from '../pdf/Exportpdf';
import Exportcsv from '../pdf/Exportcsv';
import config from "../../lib/config"
import axios from 'axios';
import $ from 'jquery'
import Web3 from "web3";

import AddNewUserModal from '../../Components/Modals/PlannedUser/AddNewUserModal';
import EditUserModal from '../../Components/Modals/PlannedUser/EditUserModal';

const PlannedUser = () => {
  const initialFormValue = {
    'PackName': "",
    'Address': "",
    'Quantity': "",
  }
  const AddUserForm = {
    'Address': "",
    'Quantity': "",
  }
  const [properties, setProperties] = useState([])
  const [Datess, SetDatess] = useState([])
  const [yearr, Setyear] = useState([])
  const [Monthsss, SetMonthss] = useState([])
  const [catagory, SetcatChange] = useState("Year")
  const [Xaxis, setXaxis] = useState([])
  const [Yaxis, setYaxis] = useState([])
  const [responsive, setresponsive] = useState(true);
  const [userdet, setUser] = useState();
  const [PackDetails, SetPackDetails] = useState([]);
  const [BuyerrsCount, SetBuyCount] = useState({});
  const [SubcriberCount, SetSubcriberCount] = useState("");
  const [NewSub, setNewSub] = useState();
  const [Notification, SetNotification] = useState([])
  const [CurrentSate, SetCurrentSate] = useState({})
  const [formValue, setFormValue] = useState(initialFormValue);
  const [PackName, SetPackName] = useState("")
  const [AddresForm, setuserForm] = useState(AddUserForm);
  const [Counttt, SetCountt] = useState([])
  const [Revenuee, SetRevenue] = useState(0)
  const [PackDetailTable, SetPackDetailTable] = useState()
  const [QunatyForEdit, SetQunatyForEdit] = useState("")
  const [exportdata, setExportdata] = useState([])


  const [addnewuser, setAddnewuser] = useState(false)
  const [editUser, setEditUser] = useState(false)

  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      backgroundColor: "#fff",
      position: "relative",
      top: "3px",
      left: "0px",
      width: "100%",
      maxWidth: "100%",
      color: "#000"
    }),
    option: (provided, state) => ({
      ...provided,
      marginBottom: "5px",
      backgroundColor: "transparent",
      maxWidth: "356px",
      color: "#fff",
      borderBottom: "#fff",
      "&:hover": {
        transition: "all 0.5s ease",
        color: "#e50914"
      },
      "&:active": {
        transition: "all 0.5s ease",
        color: "#000"
      }
    }),
    control: (provided, state) => ({
      ...provided,
      border: "1px solid transparent",
      boxShadow: "0px 0px",
      "&:hover": {
        border: "1px solid transparent",
        boxShadow: "0px 0px",
      },
      "&:focus": {
        border: "1px solid transparent"
      }
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      border: "1px solid transparent"
    })
  }

  useEffect(() => {
    ChartData();
  }, [catagory]);

  const ChartData = async () => {
    var Datass = await ChartDBData()
    var yearArr = []
    var dateArr = []
    var MonthArr = []
    var map = Datass.userValue.map((item, index) => {
      setProperties(item)
      dateArr.push(item.day)
      yearArr.push(item.year)
      MonthArr.push(item.month)
    })
    Setyear(yearArr)
    SetDatess(dateArr)
    SetMonthss(MonthArr)

    if (catagory == "Year") {
      const toFindDuplicates = yearArr => yearArr.filter((item, index) => yearArr.indexOf(item) == index)
      const duplicateElementa = toFindDuplicates(yearArr);
      var elementCounts = yearArr.reduce((count, item) => (count[item] = count[item] + 1 || 1, count), {})
      var Keyss = Object.values(elementCounts)
      var valuess = Object.keys(elementCounts)
      setXaxis(Keyss)
      setYaxis(valuess)
    }
    else if (catagory == "Month") {
      const toFindDuplicates = MonthArr => MonthArr.filter((item, index) => MonthArr.indexOf(item) == index)
      const duplicateElementa = toFindDuplicates(MonthArr);
      var elementCounts = MonthArr.reduce((count, item) => (count[item] = count[item] + 1 || 1, count), {})
      var Keyss = Object.values(elementCounts)
      var valuess = Object.keys(elementCounts)
      setXaxis(Keyss)
      setYaxis(valuess)
    }
    else if (catagory == "Day") {
      const toFindDuplicates = dateArr => dateArr.filter((item, index) => dateArr.indexOf(item) == index)
      const duplicateElementa = toFindDuplicates(dateArr);
      var elementCounts = dateArr.reduce((count, item) => (count[item] = count[item] + 1 || 1, count), {})
      var Keyss = Object.values(elementCounts)
      var valuess = Object.keys(elementCounts)
      setXaxis(Keyss)
      setYaxis(valuess)
    }
  }

  useEffect(() => {
    PackBuyerList();
    TableContent();
    BuyCount();
    NotifcationSend();
    SubScriberLsit();
    AdminPurchseCount();
    RevenueAnnualSet();
    PackDetailTableList();
  }, []);

  const PackBuyerList = async () => {
    var test = await PackBuyerssList();
    if (test.Message == 'success') {
      SetSubcriberCount(test.ListingBuyers.length)
    } else {
      toastAlert("error", "Error on Server");
    }
  };
  const TableContent = async () => {
    var test = await PackTableList();
    if (test.Message == 'success') {
      setUser(test.ListingBuyers);
    } else {
      toastAlert("error", "Error on Server");
    }
  }
  const BuyCount = async () => {
    var Count = await PackBuyerCount();
    if (Count.data.Message == "success") {
      SetPackDetails(Count.data.PackDetail)
      SetBuyCount(Count.data.BuyersCount)
    } else {
      toastAlert("error", "error in server")
    }
  }
  const NotifcationSend = async () => {
    var Count = await Notifcation();
    if (Count.data.Message == "success") {
      SetNotification(Count.data.userValue)
    } else {
      toastAlert("error", "error in server")
    }
  }
  const SubScriberLsit = async () => {
    var test = await PackBuyerssList();
    if (test.Message == 'success') {
      setNewSub(test.ListingBuyers)
    } else {
    }
  }
  const AdminPurchseCount = async () => {
    var testtt = await CountForAdminPack()
    if (testtt.data.Success == true) {
      var val = []
      let starter_len = testtt?.data?.revenue?.filter((item) => item._id == "Starter")
      if (starter_len.length > 0) val.push(starter_len[0])
      else val.push({ _id: "Starter", lastSalesDate: 0 })

      let prof_len = testtt?.data?.revenue?.filter((item) => item._id == "Professional")
      if (prof_len.length > 0) val.push(prof_len[0])
      else val.push({ _id: "Professional", lastSalesDate: 0 })

      let Agency_len = testtt?.data?.revenue?.filter((item) => item._id == "Agency")
      if (Agency_len.length > 0) val.push(Agency_len[0])
      else val.push({ _id: "Agency", lastSalesDate: 0 })

      SetCountt(val)


    }
  }
  const RevenueAnnualSet = async () => {
    var returnData = await RevenueAnnual();
    SetRevenue(returnData?.data?.revenue[0]?.sum)
  }
  const PackDetailTableList = async () => {
    var test = await PackBuyerssListTabel();
    if (test.Message == 'success') {
      SetPackDetailTable(test.ListingBuyers)
      var ddd = test.ListingBuyers.map(({ _id, ...rest }) => {
        return rest
      })
      setExportdata(ddd)
    } else {
    }
  }

  const catChangeData = async (name) => {
    SetcatChange(name)
  }

  const Modeldata = async (record) => {
    SetCurrentSate(record)
    setFormValue(record)
  }

  const hideshow = async (senddata) => {
    axios({
      method: "get",
      url: config.API + "/admin/panel/DeleteUserplan",
      params: senddata,
    }).then((data) => {
      toastAlert("success", "User Plan unSubscribed");
      window.location.reload();
    });
  };

  const onChange = (e) => {
    e.preventDefault();

    const { id, value } = e.target;
    let formData = { ...formValue, ...{ [id]: value } }
    setFormValue(formData)
  }

  const onChangeAdd = (e) => {
    e.preventDefault();
    const { id, value } = e.target;
    let formData = { ...AddresForm, ...{ [id]: value } }
    setuserForm(formData)
  }

  const AdminUserEditPlans = async () => {
    var SendData = {
      Address: formValue.Address,
      PackName: PackName,
      Userdetails: CurrentSate,
      Quantity: QunatyForEdit
    }
    if (PackName !== "" && formValue.Address !== "") {
      var Count = await AdminEditUserPlans(SendData);
      if (Count.success == true) {
        toastAlert("success", "plan upgraded to the user successfully")
        window.location.reload()
      } else {
        toastAlert("error", "Error in Upgrading plans")
      }
    } else {
      toastAlert("error", "Select Pack")
    }
    if (Count?.data?.Message == "success") {
      SetNotification(Count.data.userValue)
    } else {
      toastAlert("error", "error in server")
    }
  }

  const AdminUserAddPlans = async () => {
    var SendData = {
      Address: AddresForm?.Address,
      PackName: PackName,
      Userdetails: CurrentSate,
      Quantity: AddresForm.Quantity
    }
    var web3 = new Web3()
    var validation = web3.utils.isAddress(AddresForm.Address)
    if (validation == true) {
      if (PackName !== "") {
        var Count = await AdminEditUserPlans(SendData);
        if (Count.success == true) {
          toastAlert("success", "plan upgraded to the user successfully")
          window.location.reload()
        } else {
          toastAlert("error", "Error in Upgrading plans")
        }
      } else {
        toastAlert("error", "Select Pack")
      }
    } else {
      toastAlert("error", "Please enter valid Addess")
    }
  }

  function pageChange(pageData) {
  }
  const data = {

    options: {
      chart: {
        id: "basic-bar",
        foreColor: "#ccc",
        toolbar: {
          autoSelected: "pan",
          show: false
        }
      },
      colors: ["#2769ba"],
      stroke: {
        width: 3
      },
      grid: {
        borderColor: "#555",
        clipMarkers: false,
        yaxis: {
          lines: {
            show: false
          },
        }
      },
      dataLabels: {
        enabled: false
      },
      fill: {
        gradient: {
          enabled: true,
          opacityFrom: 0.75,
          opacityTo: 0
        }
      },
      markers: {
        size: 2,
        colors: ["#2769ba"],
        strokeColor: "#2769ba",
        strokeWidth: 3
      },
      tooltip: {
        theme: "dark"
      },
      xaxis: {
        categories: Yaxis
      }
    },
    series: [
      {
        name: "series-1",
        data: Xaxis
      },

    ]
  };

  const configdata = {
    page_size: 5,
    length_menu: [10, 20, 50],
    filename: "Users",
    no_data_text: "No user found!",

    language: {
      length_menu: "Show _MENU_ result per page",
      filter: "Filter in records...",
      info: "Showing _START_ to _END_ of _TOTAL_ records",
      pagination: {
        first: "First",
        previous: <> Previous </>,
        next: <>Next</>,
        last: "Last",
      },
    },
    show_length_menu: true,
    show_filter: true,
    show_pagination: true,
    show_info: true,
    defaultSortAsc: true,
  };

  const columns = [
    {
      key: "ind",
      text: "SNO",
      className: "name",
      align: "left",
      sortable: false,
      cell: (row, index, column, id) => <p>{index + 1}</p>,
    },
    {
      key: "image",
      text: "Profile Image",
      className: "Name",
      align: "left",
      sortable: false,
      cell: (record) => (
        <div>
          <img

            className='amin_react_table_img_align'
            src={
              record.image == ""
                ? require("../../assets/images/loader.png")
                : `${config.Back_Url}/Users/${record.PrimaryAddr}/profileImg/${record.image}`
            }
          />
        </div>
      ),
    },
    {
      key: "name",
      text: "User name",
      className: "Name",
      align: "left",
      sortable: false,
      cell: (record) => (
        <div>
          <p>{record?.name == null || "" ? record?.Address?.slice(0, 10) : record?.name}</p>
        </div>
      ),

    },
    {
      key: "PackName",
      text: "Pack purchased",
      className: "Name",
      align: "left",
      sortable: false,
      cell: (record) => (
        <div>
          <button className='admin_mdl_red_btn'>{record.PackName}</button>
        </div>
      ),
    },
    {
      key: "Address",
      text: "User Address",
      className: "Name",
      align: "left",
      sortable: false,
    },
    {
      key: "createdAt",
      text: "Date",
      className: "Date",
      align: "left",
      sortable: false,
      cell: (record) => (
        <div>
          <p>{moment(record.Date).format("MMMM,Do YYYY, hh:mm A")}</p>
        </div>
      ),
    },
    {
      key: "action",
      text: "Action",
      className: "action",
      width: 100,
      align: "left",
      sortable: false,
      cell: (record) => {

        return (
          <Fragment>
            <i class="fa-solid fa-pen table_edit_dlt_align" onClick={() => { Modeldata(record); setEditUser(true) }} />
            <i class="fa-solid fa-trash-can table_edit_dlt_align" onClick={() => {
              var re = {
                _id: record._id,
                show: record.show,
              };
              hideshow(re);
            }} />

          </Fragment>

        );
      },
    },
  ];

  return (

    <>

      {addnewuser &&
        <AddNewUserModal
          onDismiss={() => setAddnewuser(false)}
          onChangeAdd={onChangeAdd}
          SetPackName={SetPackName}
          PackDetails={PackDetails}
          AdminUserAddPlans={AdminUserAddPlans}
        />}

      {editUser &&
        <EditUserModal
          onDismiss={() => setEditUser(false)}
          formValue={formValue}
          onChange={onChange}
          SetPackName={SetPackName}
          PackDetails={PackDetails}
          SetQunatyForEdit={SetQunatyForEdit}
          AdminUserEditPlans={AdminUserEditPlans}
        />
      }

      <Container fluid className="common_bg position-relative">
        <Row>
          <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
            <Sidebar />
          </Col>
          <Col xl={10} lg={12} className='pb-4'>
            <Header title={'Planned User'} />
            <div className='common_page_scroller mt-5 pe-2'>

              <div className='row align-items-center justify-content-between mb-3'>
                <div className='col-xl-4 text-end ms-auto'>
                  <Dropdown className='not_btn'>
                    <Dropdown.Toggle className='' variant="success" id="dropdown-basic">
                      <i class="fa-regular fa-bell admin_top_bell_align" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu className='bell_dropdown_menu_align'>
                      {Notification && Notification.length && Notification.map((item, index) => {
                        { console.log("asdasdasdasdas", item); }
                        return (
                          <>
                            {
                              index < 4 && (
                                <span class="dropdown-item bell_dropdown_txt_align">{item?.name == undefined || null ? item?.Address?.slice(0, 10) : item?.name} has purchased  {item?.PackName}</span>
                              )
                            }
                          </>
                        )
                      })}

                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>

              <div>
                <div xs={12}>
                  <div className="topcardsecs">
                    <div>
                      <div className="card  blackcard_style mb-1">
                        <div className="firstrow">
                          <div>
                            <i class="fa fa-circle admint_nrm_round admin_green_round mb-2" />
                          </div>
                          <div className="div_text">Active Subscribers</div>
                        </div>

                        <div className="graph_align">
                          <div className="count_dtls">
                            <span className="count_txt">{SubcriberCount}</span>
                            <br />
                          </div>
                        </div>
                      </div>
                    </div>



                    {Counttt.length > 0 && Counttt.map((item, index) => {
                      return (
                        <>
                          <div>
                            <>

                              <div className="card five_div_card blackcard_style mb-1">
                                <div className="firstrow">
                                  <div>
                                    <i class="fa fa-circle admint_nrm_round admin_red_round mb-2"></i>
                                  </div>
                                  <span className="div_text">{item._id}</span>
                                </div>

                                <div className="graph_align">
                                  <div className="count_dtls">

                                    <br />
                                    <p className='admint_count_txt'>{item.lastSalesDate}</p>

                                  </div>
                                 
                                </div>
                              </div>

                            </>

                          </div>
                        </>)
                    })}



                    <div>
                      <div className="card five_div_card blackcard_style mb-1">
                        <div className="firstrow">
                          <div>
                            <i class="fa fa-circle admint_nrm_round admin_sandal_round mb-2"></i>
                          </div>
                          <div className="div_text">Annual Recurring Revenue(ARR)</div>
                        </div>

                        <div className="graph_align">
                          <div className="count_dtls">
                            <span className="count_txt">{" $ " + Revenuee == undefined ? "0" : Revenuee}</span>
                            <br />

                            
                          </div>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Row className='mt-1'>
                <Col xxl={8} xl={8} lg={8} md={8} sm={12} xs={12} className='mt-3'>
                  <div className='admin_chart_align w-100'>                 
                    <div className='d-flex justify-content-between'>
                      <p className='admin_new_subscribers text-white mb-0'>Number of Subscribers</p>
                      <Dropdown>
                        <Dropdown.Toggle className='normalbtn' variant="success" id="dropdown-basic">
                        {catagory}
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          <Dropdown.Item onClick={() =>
                                catChangeData("Day")}>Day</Dropdown.Item>
                          <Dropdown.Item onClick={() =>
                                catChangeData("Month")}>Month</Dropdown.Item>
                          <Dropdown.Item onClick={() =>
                                catChangeData("Year")}>Year</Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                    </div>
                    <Chart options={data?.options} className="tradechart"
                      series={data?.series}
                      type="bar" height="200" width="100%" />
                  </div>
                </Col>
                <Col xxl={4} xl={4} lg={4} md={4} sm={12} xs={12} className='mt-3'>
                <div className='subscriber_whole_dtls_align w-100'>
                <p className='admin_new_subscribers text-white mb-2'>New Subscribers</p>
                    {NewSub && NewSub.length > 0 ?
                      <div>
                        {NewSub && NewSub.map((item, index) => {
                          return (
                            <>
                              {
                                index < 5 && (
                                  <div className='admin_subscriber_dtls_align w-100'>
                                    {item.image == "" || item.image == null ?
                                      <img className='admin_dropdown_img_align' src={require('../../assets/images/faces/marc.jpg')} />
                                      :
                                      <img className='admin_dropdown_img_align' src={`${config.Back_Url}/Users/${item.PrimaryAddr}/profileImg/${item.image}`} />
                                    }
                                    <div>
                                      <p className='subscribers_align_dtls mb-0'>{item.name == "" || item.name == null ? item?.Address?.slice(0, 10) : item?.name}<span className='admin_badge_icon_align'><i class="fa-solid fa-certificate admin_certificate_icon" /><i class="fa-solid fa-check admin_tick_icon" /></span></p>


                                      <span className='follwers_count_align'>{item.FollowersCount == undefined ? "" : item.FollowersCount + " Followers"}</span>
                                    </div>
                                  </div>
                                )
                              }
                            </>
                          )
                        })}
                      </div> :
                      <h3>No Subscribers Found</h3>}
                  </div>
                </Col>

              </Row>

              <Row className='mt-3'>
                <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                <div className='d-flex justify-content-between align-items-center mb-3'>
                    <p className='admin_new_subscribers'>List of Users</p>


                    <button className='admin_mdl_red_btn py-2' onClick={() => setAddnewuser(true)}>Add New Users</button>


                  </div>
                  <ReactDatatable
                    responsive={responsive}
                    className="table table-striped table-responsive react_table_border_align"
                    config={configdata}
                    records={PackDetailTable}
                    columns={columns}
                    onPageChange={pageChange()}

                  />
                  <div className='bottom_btn_comp mt-3'>
                    <Exportexcel excelData={exportdata} fileName={'Planned Users'} />
                    <Exportpdf pdfData={exportdata} fileName={'Planned Users'} />
                    <Exportcsv csvData={exportdata} fileName={'Planned Users'} />
                  </div>
                </Col>
              </Row>

            </div>



            {/* {/ Edit Modal Content /} */}
            <div class="modal fade newthememodal" id="editUserModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
              <div class="modal-dialog  modal-dialog-scrollable modal-xl">
                <div class="modal-content">
                  <div class="modal-header edituser_modal_body_align">
                    <h5 class="modal-title edit_header_title_align" id="staticBackdropLabel">Add New User / Edit User </h5>
                    <button type="button" class="close modal_cls_btn_align" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body edituser_modal_body_align">
                    <div className=''>
                      <div container spacing={1}>
                        
                        <div item xxl={6} xl={6} lg={6} md={6} sm={6} xs={12} >
                          <input type="text" id="Address" className='edit_inputs_align' placeholder='wallet Address*' name="wallet address" value={formValue.Address} onChange={onChange}
                          />
                        </div>


                        <div item xxl={6} xl={6} lg={6} md={6} sm={6} xs={12}>
                          <input type="text" id="PackName" className='edit_inputs_align' placeholder='First Name*' name="wallet address" onChange={onChange}
                            value={formValue.PackName} disabled />
                        </div>
                       
                        <div item xxl={6} xl={6} lg={6} md={6} sm={6} xs={12}>
                          <Select
                            className="yes1 form-control primary_inp select1 selxet_app h-40 p-0"
                            onChange={(e) => SetPackName(e.value)}
                            options={PackDetails}
                            label="Single select"
                            isSearchable={false}
                            styles={customStyles}

                            classNamePrefix="react-select"
                            formControlProps={{
                              fullWidth: true,
                            }}
                          />
                        </div>
                        <div item xxl={6} xl={6} lg={6} md={6} sm={6} xs={12} >
                          <input type="text" id="Quantity" className='edit_inputs_align' placeholder='Enter Quantity*' name="wallet address" onChange={(e) => SetQunatyForEdit(e.target.value)}
                          />
                        </div>
                        <div container className='mt-1' spacing={1}>
                        
                        </div>

                        <div container className='mt-1' spacing={1}>
                          <div item xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} >
                            <div className='adm_mdl_add_btn'>
                              <button color="primary" type="submit" className="sendid" onClick={() => AdminUserEditPlans()}>Add</button>
                            </div>
                          </div>
                        
                        </div>
                      </div>
                      <div class="container-fluid edit_table_container_align">
                        <div class="table-responsive" style={{ position: "relative", zIndex: 0 }}>
                          <table class="table edit_user_table_align">
                            <thead>
                              <tr>
                                <th scope="col">Module Permission</th>
                                <th scope="col">LazyMint ERC721 & ERC 1155</th>
                                <th scope="col">Bulk LazyMint </th>
                                <th scope="col">SoulBound Tokens</th>
                                <th scope="col">Token Scanner</th>
                                <th scope="col">DashBoard And Profile</th>
                              </tr>
                            </thead>
                            {PackDetails && PackDetails.length > 0 && PackDetails.map((item, index) => {
                              return (
                                <tbody>
                                  <tr>

                                    <td className='lft_frst_td' scope="row">{item.PackName}</td>
                                    {item.ERC == "true" ?
                                      <td><input type="checkbox" className='table_check_align' id="ERC" name="ERC" value="ERC" checked="checked" /></td>
                                      :
                                      <td><input type="checkbox" className='table_check_align' id="ERC" name="ERC" value="ERC" disabled /></td>

                                    }
                                    {item.Bulkminting == "true" ?
                                      <td><input type="checkbox" className='table_check_align' id="SoulBound" name="SoulBound" value="SoulBound" checked="checked" /></td>
                                      :
                                      <td><input type="checkbox" className='table_check_align' id="SoulBound" name="SoulBound" value="SoulBound" disabled /></td>
                                    }
                                    {item.Soulbound == "true" ?
                                      <td><input type="checkbox" className='table_check_align' id="TokenGating" name="TokenGating" value="TokenGating" checked="checked" /></td>
                                      :
                                      <td><input type="checkbox" className='table_check_align' id="TokenGating" name="TokenGating" value="TokenGating" disabled /></td>
                                    }
                                    {item.TokenScanner == "true" ?
                                      <td><input type="checkbox" className='table_check_align' id="TokenScanner" name="TokenScanner" value="TokenScanner" checked="checked" /></td>
                                      :
                                      <td><input type="checkbox" className='table_check_align' id="TokenScanner" name="TokenScanner" value="TokenScanner" disabled /></td>
                                    }
                                    {item.DashBoardAndProfile == "true" ?
                                      <td><input type="checkbox" className='table_check_align' id="DashBoardAndProfile" name="DashBoardAndProfile" value="DashBoardAndProfile" checked="checked" /></td>
                                      :

                                      <td><input type="checkbox" className='table_check_align' id="DashBoardAndProfile" name="DashBoardAndProfile" value="DashBoardAndProfile" disabled /></td>
                                    }

                                    {item.DomainCampaign == "true" ?
                                      <td><input type="checkbox" className='table_check_align' id="DomainCampaign" name="DomainCampaign" value="DomainCampaign" checked="checked" /></td>
                                      :

                                      <td><input type="checkbox" className='table_check_align' id="DomainCampaign" name="DomainCampaign" value="DomainCampaign" disabled /></td>
                                    }


                                  </tr >
                                  
                                </tbody >
                              )
                            })}

                          </table >
                        </div >

                      </div >
                    </div >
                  </div >

                </div >
              </div >
            </div >

            {/* {/ End of Edit Modal Content /} */}

            {/* Add user Model */}
            <div class="modal fade newthememodal" id="AddUserModal" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
              <div class="modal-dialog  modal-dialog-scrollable modal-xl">
                <div class="modal-content">
                  <div class="modal-header edituser_modal_body_align">
                    <h5 class="modal-title edit_header_title_align" id="staticBackdropLabel">Add New User / Edit User1</h5>
                    <button type="button" class="close modal_cls_btn_align" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body edituser_modal_body_align">
                    <div className=''>
                      <div container spacing={1}>
                        
                        <div item xxl={6} xl={6} lg={6} md={6} sm={6} xs={12} >
                          <input type="text" id="Address" className='edit_inputs_align' placeholder='wallet Address*' name="wallet address" onChange={onChangeAdd}
                          />
                        </div>
                        <div item xxl={6} xl={6} lg={6} md={6} sm={6} xs={12}>
                          <Select
                            className="yes1 form-control primary_inp select1 selxet_app h-40 p-0"
                            onChange={(e) => SetPackName(e.value)}
                            options={PackDetails}
                            label="Single select"
                            isSearchable={false}
                            styles={customStyles}
                            classNamePrefix="react-select"
                            formControlProps={{
                              fullWidth: true,
                            }}
                          />
                        </div>
                        <div item xxl={6} xl={6} lg={6} md={6} sm={6} xs={12} >
                          <input type="text" id="Quantity" className='edit_inputs_align' placeholder='Enter Quantity*' name="wallet address" onChange={onChangeAdd}
                          />
                        </div>
                        <div container className='mt-1' spacing={1}>
                        </div>

                        <div container className='mt-1' spacing={1}>
                          <div item xxl={12} xl={12} lg={12} md={12} sm={12} xs={12} >
                            <div className='adm_mdl_add_btn'>
                              <button color="primary" type="submit" className="admin_mdl_red_btn" onClick={() => AdminUserAddPlans()}>Add</button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="container-fluid edit_table_container_align">
                        <div class="table-responsive" style={{ position: "relative", zIndex: 0 }}>
                          <table class="table edit_user_table_align">
                            <thead>
                              <tr>
                                <th scope="col">Module Permission</th>
                                <th scope="col">LazyMint ERC 721 & ERC 1155</th>
                                <th scope="col">Bulk LazyMint</th>
                                <th scope="col">SoulBound Tokens</th>
                                <th scope="col">Token Scanner</th>
                                <th scope="col">Dashboard And Profile</th>
                                <th scope="col">Campaign Page</th>
                              </tr>
                            </thead>
                            {PackDetails && PackDetails.length > 0 && PackDetails.map((item, index) => {
                              return (
                                <tbody>
                                  <tr>
                                    <td className='lft_frst_td' scope="row">{item.PackName}</td>
                                    {item.ERC == "true" ?
                                      <td><input type="checkbox" className='table_check_align' id="ERC" name="ERC" value="ERC" checked="checked" /></td>
                                      :
                                      <td><input type="checkbox" className='table_check_align' id="ERC" name="ERC" value="ERC" disabled /></td>

                                    }
                                    {item.Bulkminting == "true" ?
                                      <td><input type="checkbox" className='table_check_align' id="SoulBound" name="SoulBound" value="SoulBound" checked="checked" /></td>
                                      :
                                      <td><input type="checkbox" className='table_check_align' id="SoulBound" name="SoulBound" value="SoulBound" disabled /></td>
                                    }
                                    {item.Soulbound == "true" ?
                                      <td><input type="checkbox" className='table_check_align' id="TokenGating" name="TokenGating" value="TokenGating" checked="checked" /></td>
                                      :
                                      <td><input type="checkbox" className='table_check_align' id="TokenGating" name="TokenGating" value="TokenGating" disabled /></td>
                                    }
                                    {item.TokenScanner == "true" ?
                                      <td><input type="checkbox" className='table_check_align' id="TokenScanner" name="TokenScanner" value="TokenScanner" checked="checked" /></td>
                                      :
                                      <td><input type="checkbox" className='table_check_align' id="TokenScanner" name="TokenScanner" value="TokenScanner" disabled /></td>
                                    }
                                    {item.DashBoardAndProfile == "true" ?
                                      <td><input type="checkbox" className='table_check_align' id="DashBoardAndProfile" name="DashBoardAndProfile" value="DashBoardAndProfile" checked="checked" /></td>
                                      :

                                      <td><input type="checkbox" className='table_check_align' id="DashBoardAndProfile" name="DashBoardAndProfile" value="DashBoardAndProfile" disabled /></td>
                                    }
                                    {item.DomainCampaign == "true" ?
                                      <td><input type="checkbox" className='table_check_align' id="DomainCampaign" name="DomainCampaign" value="DomainCampaign" checked="checked" /></td>
                                      :

                                      <td><input type="checkbox" className='table_check_align' id="DomainCampaign" name="DomainCampaign" value="DomainCampaign" disabled /></td>
                                    }

                                  </tr >
                                </tbody >
                              )
                            })}

                          </table >
                        </div >

                      </div >
                    </div >
                  </div >

                </div >
              </div >
            </div >

          </Col>
        </Row>
      </Container>
    </>
  )
}

export default PlannedUser